import { useMemo } from 'react'

import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text'

import useSchoolContext from 'app/KinerjaKSPage/hooks/useSchoolContext'

import ImgTermConditionTNCList from 'assets/icons/img-term-condition-tnc-list.svg'

interface TabRangkumanReadyProps {
  onClickBackToHome?: () => any
}

const TabRangkumanReady = ({
  onClickBackToHome = () => {},
}: TabRangkumanReadyProps) => {
  const schoolCtx = useSchoolContext()
  const isPltKSRole =
    schoolCtx && schoolCtx.selectedSchool
      ? schoolCtx.selectedSchool.role === 'KS_PLT' ||
        schoolCtx.selectedSchool.role === 'KS_PLT_SPNF'
      : false

  const steps = useMemo(() => {
    return [
      {
        title: 'Perencanaan akan otomatis disetujui',
        description: isPltKSRole
          ? 'Perencanaan Kinerja Anda akan otomatis disetujui dan disampaikan ke Pejabat Penilai Kinerja.'
          : 'Perencanaan Kinerja Anda akan otomatis disetujui dan disampaikan ke Pejabat Penilai Kinerja. Perencanaan juga akan otomatis dikirim ke E-Kinerja dalam 1x24 jam.',
      },
      {
        title: 'Lakukan tahap berikutnya: Pelaksanaan Kinerja',
      },
    ]
  }, [isPltKSRole])

  return (
    <div className="p-9 flex justify-center">
      <div className="w-[500px] p-9 flex flex-col">
        <ImgTermConditionTNCList width={84} height={84} />

        <Text variant="heading-lg" className="mt-4">
          Perencanaan Kinerja selesai!
        </Text>

        <div className="flex flex-col gap-4 mt-4">
          {steps.map(({ title, description }, i) => (
            <div key={title} className="flex gap-2">
              <div className="flex justify-center items-center bg-gray-80 rounded-full p-3 self-start">
                <Text variant="body-sm" color="inverse" className="absolute">
                  {i + 1}
                </Text>
              </div>
              <div className="flex flex-col gap-1">
                <Text variant="action">{title}</Text>
                {description && (
                  <Text variant="body-sm" color="subdued">
                    {description}
                  </Text>
                )}
              </div>
            </div>
          ))}
        </div>

        <Button
          size="lg"
          color="black"
          className="mt-4"
          fullWidth
          onClick={onClickBackToHome}
        >
          Ke Pelaksanaan Kinerja
        </Button>
      </div>
    </div>
  )
}

export default TabRangkumanReady
